import { TableBody } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useEffect } from 'react';
import { ICurationTableStudy } from '../hooks/useCuratorTableState.types';
import CurationBoardAIInterfaceCuratorTableRow from './CurationBoardAIInterfaceCuratorTableRow';

const isNotBrowserOrIsFirefox = typeof window === 'undefined' || navigator.userAgent.includes('Firefox');

const CurationBoardAIInterfaceCuratorTableBody = ({
    table,
    onSelect,
    tableContainerElement,
    selectedStub,
}: {
    table: Table<ICurationTableStudy>;
    onSelect: (id: string | undefined) => void;
    tableContainerElement: HTMLDivElement | null;
    selectedStub: ICurationTableStudy | undefined;
}) => {
    const rows = table.getRowModel().rows;
    const virtualizer = useVirtualizer<HTMLDivElement, HTMLTableRowElement>({
        count: rows.length,
        estimateSize: () => 100,
        getScrollElement: () => tableContainerElement,
        measureElement: isNotBrowserOrIsFirefox ? undefined : (e) => e?.getBoundingClientRect()?.height,
        overscan: 5,
    });

    useEffect(() => {
        if (!selectedStub) return;
        setTimeout(() => {
            const rowIndex = rows.findIndex((r) => r.original.id === selectedStub.id);
            virtualizer.scrollToIndex(rowIndex, { align: 'start' });
            // reset the selected stub as we are back in table view and we dont want to
            // scroll to this stub anymore
            onSelect(undefined);
        }, 0);
    }, [rows, selectedStub, virtualizer, onSelect]);

    return (
        <TableBody style={{ display: 'grid', height: `${virtualizer.getTotalSize()}px`, position: 'relative' }}>
            {virtualizer.getVirtualItems().map((virtualRow) => {
                const row = rows[virtualRow.index];
                return (
                    <CurationBoardAIInterfaceCuratorTableRow
                        onSelect={onSelect}
                        key={row.id}
                        virtualRow={virtualRow}
                        virtualizer={virtualizer}
                        data={row}
                    />
                );
            })}
        </TableBody>
    );
};

export default CurationBoardAIInterfaceCuratorTableBody;
